export const USER_ROLES = {
  ADMIN: "admin",
  EDITOR: "editor",
  VIEWER: "viewer",
};
export const USERS_TEAMS = {
  YANTRIX_ADMIIN_ALL: "yantrix-admin-all",
  YANTRIX_ADMIIN: "yantrix-admin",
  YANTRIX_ADMIIN_MANAGER: "yantrix-admin-manager",
};
export const MARKET_CAP = {
  STARTUP: "Startup",
  MSME: "Msme",
  LARGECAP: "Largecap",
};
export const SIC = {
  1110: "1110",
  1120: "1120",
  1130: "1130",
  1140: "1140",
  1150: "1150",
  1160: "1160",
  1190: "1190",
  1210: "1210",
  1220: "1220",
  1230: "1230",
  1240: "1240",
  1250: "1250",
  1260: "1260",
  1270: "1270",
  1280: "1280",
  1290: "1290",
  1300: "1300",
  1410: "1410",
  1420: "1420",
  1430: "1430",
  1440: "1440",
  1450: "1450",
  1460: "1460",
  1470: "1470",
  1490: "1490",
  1500: "1500",
  1610: "1610",
  1621: "1621",
  1629: "1629",
  1630: "1630",
  1640: "1640",
  1700: "1700",
  2100: "2100",
  2200: "2200",
  2300: "2300",
  2400: "2400",
  3110: "3110",
  3120: "3120",
  3210: "3210",
  3220: "3220",
  5101: "5101",
  5102: "5102",
  5200: "5200",
  6100: "6100",
  6200: "6200",
  7100: "7100",
  7210: "7210",
  7290: "7290",
  8110: "8110",
  8120: "8120",
  8910: "8910",
  8920: "8920",
  8930: "8930",
  8990: "8990",
  9100: "9100",
  9900: "9900",
  10110: "10110",
  10120: "10120",
  10130: "10130",
  10200: "10200",
  10310: "10310",
  10320: "10320",
  10390: "10390",
  10410: "10410",
  10420: "10420",
  10511: "10511",
  10512: "10512",
  10519: "10519",
  10520: "10520",
  10611: "10611",
  10612: "10612",
  10620: "10620",
  10710: "10710",
  10720: "10720",
  10730: "10730",
  10810: "10810",
  10821: "10821",
  10822: "10822",
  10831: "10831",
  10832: "10832",
  10840: "10840",
  10850: "10850",
  10860: "10860",
  10890: "10890",
  10910: "10910",
  10920: "10920",
  11010: "11010",
  11020: "11020",
  11030: "11030",
  11040: "11040",
  11050: "11050",
  11060: "11060",
  11070: "11070",
  12000: "12000",
  13100: "13100",
  13200: "13200",
  13300: "13300",
  13910: "13910",
  13921: "13921",
  13922: "13922",
  13923: "13923",
  13931: "13931",
  13939: "13939",
  13940: "13940",
  13950: "13950",
  13960: "13960",
  13990: "13990",
  14110: "14110",
  14120: "14120",
  14131: "14131",
  14132: "14132",
  14141: "14141",
  14142: "14142",
  14190: "14190",
  14200: "14200",
  14310: "14310",
  14390: "14390",
  15110: "15110",
  15120: "15120",
  15200: "15200",
  16100: "16100",
  16210: "16210",
  16220: "16220",
  16230: "16230",
  16240: "16240",
  16290: "16290",
  17110: "17110",
  17120: "17120",
  17211: "17211",
  17219: "17219",
  17220: "17220",
  17230: "17230",
  17240: "17240",
  17290: "17290",
  18110: "18110",
  18121: "18121",
  18129: "18129",
  18130: "18130",
  18140: "18140",
  18201: "18201",
  18202: "18202",
  18203: "18203",
  19100: "19100",
  19201: "19201",
  19209: "19209",
  20110: "20110",
  20120: "20120",
  20130: "20130",
  20140: "20140",
  20150: "20150",
  20160: "20160",
  20170: "20170",
  20200: "20200",
  20301: "20301",
  20302: "20302",
  20411: "20411",
  20412: "20412",
  20420: "20420",
  20510: "20510",
  20520: "20520",
  20530: "20530",
  20590: "20590",
  20600: "20600",
  21100: "21100",
  21200: "21200",
  22110: "22110",
  22190: "22190",
  22210: "22210",
  22220: "22220",
  22230: "22230",
  22290: "22290",
  23110: "23110",
  23120: "23120",
  23130: "23130",
  23140: "23140",
  23190: "23190",
  23200: "23200",
  23310: "23310",
  23320: "23320",
  23410: "23410",
  23420: "23420",
  23430: "23430",
  23440: "23440",
  23490: "23490",
  23510: "23510",
  23520: "23520",
  23610: "23610",
  23620: "23620",
  23630: "23630",
  23640: "23640",
  23650: "23650",
  23690: "23690",
  23700: "23700",
  23910: "23910",
  23990: "23990",
  24100: "24100",
  24200: "24200",
  24310: "24310",
  24320: "24320",
  24330: "24330",
  24340: "24340",
  24410: "24410",
  24420: "24420",
  24430: "24430",
  24440: "24440",
  24450: "24450",
  24460: "24460",
  24510: "24510",
  24520: "24520",
  24530: "24530",
  24540: "24540",
  25110: "25110",
  25120: "25120",
  25210: "25210",
  25290: "25290",
  25300: "25300",
  25400: "25400",
  25500: "25500",
  25610: "25610",
  25620: "25620",
  25710: "25710",
  25720: "25720",
  25730: "25730",
  25910: "25910",
  25920: "25920",
  25930: "25930",
  25940: "25940",
  25990: "25990",
  26110: "26110",
  26120: "26120",
  26200: "26200",
  26301: "26301",
  26309: "26309",
  26400: "26400",
  26511: "26511",
  26512: "26512",
  26513: "26513",
  26514: "26514",
  26520: "26520",
  26600: "26600",
  26701: "26701",
  26702: "26702",
  26800: "26800",
  27110: "27110",
  27120: "27120",
  27200: "27200",
  27310: "27310",
  27320: "27320",
  27330: "27330",
  27400: "27400",
  27510: "27510",
  27520: "27520",
  27900: "27900",
  28110: "28110",
  28120: "28120",
  28131: "28131",
  28132: "28132",
  28140: "28140",
  28150: "28150",
  28210: "28210",
  28220: "28220",
  28230: "28230",
  28240: "28240",
  28250: "28250",
  28290: "28290",
  28301: "28301",
  28302: "28302",
  28410: "28410",
  28490: "28490",
  28910: "28910",
  28921: "28921",
  28922: "28922",
  28923: "28923",
  28930: "28930",
  28940: "28940",
  28950: "28950",
  28960: "28960",
  28990: "28990",
  29100: "29100",
  29201: "29201",
  29202: "29202",
  29203: "29203",
  29310: "29310",
  29320: "29320",
  30110: "30110",
  30120: "30120",
  30200: "30200",
  30300: "30300",
  30400: "30400",
  30910: "30910",
  30920: "30920",
  30990: "30990",
  31010: "31010",
  31020: "31020",
  31030: "31030",
  31090: "31090",
  32110: "32110",
  32120: "32120",
  32130: "32130",
  32200: "32200",
  32300: "32300",
  32401: "32401",
  32409: "32409",
  32500: "32500",
  32910: "32910",
  32990: "32990",
  33110: "33110",
  33120: "33120",
  33130: "33130",
  33140: "33140",
  33150: "33150",
  33160: "33160",
  33170: "33170",
  33190: "33190",
  33200: "33200",
  35110: "35110",
  35120: "35120",
  35130: "35130",
  35140: "35140",
  35210: "35210",
  35220: "35220",
  35230: "35230",
  35300: "35300",
  36000: "36000",
  37000: "37000",
  38110: "38110",
  38120: "38120",
  38210: "38210",
  38220: "38220",
  38310: "38310",
  38320: "38320",
  39000: "39000",
  41100: "41100",
  41201: "41201",
  41202: "41202",
  42110: "42110",
  42120: "42120",
  42130: "42130",
  42210: "42210",
  42220: "42220",
  42910: "42910",
  42990: "42990",
  43110: "43110",
  43120: "43120",
  43130: "43130",
  43210: "43210",
  43220: "43220",
  43290: "43290",
  43310: "43310",
  43320: "43320",
  43330: "43330",
  43341: "43341",
  43342: "43342",
  43390: "43390",
  43910: "43910",
  43991: "43991",
  43999: "43999",
  45111: "45111",
  45112: "45112",
  45190: "45190",
  45200: "45200",
  45310: "45310",
  45320: "45320",
  45400: "45400",
  46110: "46110",
  46120: "46120",
  46130: "46130",
  46140: "46140",
  46150: "46150",
  46160: "46160",
  46170: "46170",
  46180: "46180",
  46190: "46190",
  46210: "46210",
  46220: "46220",
  46230: "46230",
  46240: "46240",
  46310: "46310",
  46320: "46320",
  46330: "46330",
  46341: "46341",
  46342: "46342",
  46350: "46350",
  46360: "46360",
  46370: "46370",
  46380: "46380",
  46390: "46390",
  46410: "46410",
  46420: "46420",
  46431: "46431",
  46439: "46439",
  46440: "46440",
  46450: "46450",
  46460: "46460",
  46470: "46470",
  46480: "46480",
  46491: "46491",
  46499: "46499",
  46510: "46510",
  46520: "46520",
  46610: "46610",
  46620: "46620",
  46630: "46630",
  46640: "46640",
  46650: "46650",
  46660: "46660",
  46690: "46690",
  46711: "46711",
  46719: "46719",
  46720: "46720",
  46730: "46730",
  46740: "46740",
  46750: "46750",
  46760: "46760",
  46770: "46770",
  46900: "46900",
  47110: "47110",
  47190: "47190",
  47210: "47210",
  47220: "47220",
  47230: "47230",
  47240: "47240",
  47250: "47250",
  47260: "47260",
  47290: "47290",
  47300: "47300",
  47410: "47410",
  47421: "47421",
  47429: "47429",
  47430: "47430",
  47510: "47510",
  47520: "47520",
  47530: "47530",
  47540: "47540",
  47591: "47591",
  47599: "47599",
  47610: "47610",
  47620: "47620",
  47630: "47630",
  47640: "47640",
  47650: "47650",
  47710: "47710",
  47721: "47721",
  47722: "47722",
  47730: "47730",
  47741: "47741",
  47749: "47749",
  47750: "47750",
  47760: "47760",
  47770: "47770",
  47781: "47781",
  47782: "47782",
  47789: "47789",
  47791: "47791",
  47799: "47799",
  47810: "47810",
  47820: "47820",
  47890: "47890",
  47910: "47910",
  47990: "47990",
  49100: "49100",
  49200: "49200",
  49311: "49311",
  49319: "49319",
  49320: "49320",
  49390: "49390",
  49410: "49410",
  49420: "49420",
  49500: "49500",
  50100: "50100",
  50200: "50200",
  50300: "50300",
  50400: "50400",
  51101: "51101",
  51102: "51102",
  51210: "51210",
  51220: "51220",
  52101: "52101",
  52102: "52102",
  52103: "52103",
  52211: "52211",
  52212: "52212",
  52213: "52213",
  52219: "52219",
  52220: "52220",
  52230: "52230",
  52241: "52241",
  52242: "52242",
  52243: "52243",
  52290: "52290",
  53100: "53100",
  53201: "53201",
  53202: "53202",
  55100: "55100",
  55201: "55201",
  55202: "55202",
  55209: "55209",
  55300: "55300",
  55900: "55900",
  56101: "56101",
  56102: "56102",
  56103: "56103",
  56210: "56210",
  56290: "56290",
  56301: "56301",
  56302: "56302",
  58110: "58110",
  58120: "58120",
  58130: "58130",
  58141: "58141",
  58142: "58142",
  58190: "58190",
  58210: "58210",
  58290: "58290",
  59111: "59111",
  59112: "59112",
  59113: "59113",
  59120: "59120",
  59131: "59131",
  59132: "59132",
  59133: "59133",
  59140: "59140",
  59200: "59200",
  60100: "60100",
  60200: "60200",
  61100: "61100",
  61200: "61200",
  61300: "61300",
  61900: "61900",
  62011: "62011",
  62012: "62012",
  62020: "62020",
  62030: "62030",
  62090: "62090",
  63110: "63110",
  63120: "63120",
  63910: "63910",
  63990: "63990",
  64110: "64110",
  64191: "64191",
  64192: "64192",
  64201: "64201",
  64202: "64202",
  64203: "64203",
  64204: "64204",
  64205: "64205",
  64209: "64209",
  64301: "64301",
  64302: "64302",
  64303: "64303",
  64304: "64304",
  64305: "64305",
  64306: "64306",
  64910: "64910",
  64921: "64921",
  64922: "64922",
  64929: "64929",
  64991: "64991",
  64992: "64992",
  64999: "64999",
  65110: "65110",
  65120: "65120",
  65201: "65201",
  65202: "65202",
  65300: "65300",
  66110: "66110",
  66120: "66120",
  66190: "66190",
  66210: "66210",
  66220: "66220",
  66290: "66290",
  66300: "66300",
  68100: "68100",
  68201: "68201",
  68202: "68202",
  68209: "68209",
  68310: "68310",
  68320: "68320",
  69101: "69101",
  69102: "69102",
  69109: "69109",
  69201: "69201",
  69202: "69202",
  69203: "69203",
  70100: "70100",
  70210: "70210",
  70221: "70221",
  70229: "70229",
  71111: "71111",
  71112: "71112",
  71121: "71121",
  71122: "71122",
  71129: "71129",
  71200: "71200",
  72110: "72110",
  72190: "72190",
  72200: "72200",
  73110: "73110",
  73120: "73120",
  73200: "73200",
  74100: "74100",
  74201: "74201",
  74202: "74202",
  74203: "74203",
  74209: "74209",
  74300: "74300",
  74901: "74901",
  74902: "74902",
  74909: "74909",
  74990: "74990",
  75000: "75000",
  77110: "77110",
  77120: "77120",
  77210: "77210",
  77220: "77220",
  77291: "77291",
  77299: "77299",
  77310: "77310",
  77320: "77320",
  77330: "77330",
  77341: "77341",
  77342: "77342",
  77351: "77351",
  77352: "77352",
  77390: "77390",
  77400: "77400",
  78101: "78101",
  78109: "78109",
  78200: "78200",
  78300: "78300",
  79110: "79110",
  79120: "79120",
  79901: "79901",
  79909: "79909",
  80100: "80100",
  80200: "80200",
  80300: "80300",
  81100: "81100",
  81210: "81210",
  81221: "81221",
  81222: "81222",
  81223: "81223",
  81229: "81229",
  81291: "81291",
  81299: "81299",
  81300: "81300",
  82110: "82110",
  82190: "82190",
  82200: "82200",
  82301: "82301",
  82302: "82302",
  82911: "82911",
  82912: "82912",
  82920: "82920",
  82990: "82990",
  84110: "84110",
  84120: "84120",
  84130: "84130",
  84210: "84210",
  84220: "84220",
  84230: "84230",
  84240: "84240",
  84250: "84250",
  84300: "84300",
  85100: "85100",
  85200: "85200",
  85310: "85310",
  85320: "85320",
  85410: "85410",
  85421: "85421",
  85422: "85422",
  85510: "85510",
  85520: "85520",
  85530: "85530",
  85590: "85590",
  85600: "85600",
  86101: "86101",
  86102: "86102",
  86210: "86210",
  86220: "86220",
  86230: "86230",
  86900: "86900",
  87100: "87100",
  87200: "87200",
  87300: "87300",
  87900: "87900",
  88100: "88100",
  88910: "88910",
  88990: "88990",
  90010: "90010",
  90020: "90020",
  90030: "90030",
  90040: "90040",
  91011: "91011",
  91012: "91012",
  91020: "91020",
  91030: "91030",
  91040: "91040",
  92000: "92000",
  93110: "93110",
  93120: "93120",
  93130: "93130",
  93191: "93191",
  93199: "93199",
  93210: "93210",
  93290: "93290",
  94110: "94110",
  94120: "94120",
  94200: "94200",
  94910: "94910",
  94920: "94920",
  94990: "94990",
  95110: "95110",
  95120: "95120",
  95210: "95210",
  95220: "95220",
  95230: "95230",
  95240: "95240",
  95250: "95250",
  95290: "95290",
  96010: "96010",
  96020: "96020",
  96030: "96030",
  96040: "96040",
  96090: "96090",
  97000: "97000",
  98000: "98000",
  98100: "98100",
  98200: "98200",
  99000: "99000",
  99999: "99999",
};